// @core/api/endpoints/tenant/transfer_tenant_ownership.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantResponse,
  TransferTenantOwnershipRequest,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Transfer tenant ownership
 * Transfers full ownership of the tenant to another user. The current owner loses owner privileges and the new owner gains complete control over the tenant.
 */
export async function TransferTenantOwnership(
  tenant_id: string,
  data: TransferTenantOwnershipRequest,
  options?: RequestOptions
): Promise<TenantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/ownership/transfer`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.post<TenantResponse>(requestPath, data, requestOptions);
}
